import React from 'preact/compat';
import { useSelfServiceFormContext } from './context';

export function WhereToBuy() {
    const {
        links: { range },
    } = useSelfServiceFormContext();

    return (
        <div>
            <p>Please view our <a href={range}>range</a> to find out where to buy our products. Retailers are found on individual product pages.</p>
        </div>
    );
}

export function Recipes() {
    const {
        links: { recipes },
    } = useSelfServiceFormContext();

    return (
        <div>
            <p>For a list of our recipes please visit our <a href={recipes}>recipes page</a>.</p>
        </div>
    );
}

export function TradeEnquiry() {
    const {
        emailAddresses: { trade },
    } = useSelfServiceFormContext();

    return (
        <div>
            <p>Please contact the sales team on <a href={`mailto:${trade}`}>{trade}</a>, thank you.</p>
        </div>
    );
}

export function WorkingWithUs() {
    const {
        emailAddresses: { hr },
    } = useSelfServiceFormContext();

    return (
        <div>
            <p>Please contact the HR team on <a href={`mailto:${hr}`}>{hr}</a>, thank you.</p>
        </div>
    );
}

export function Recycling() {
    const {
        links: { recycling },
    } = useSelfServiceFormContext();

    return (
        <div>
            <p>Find out more about <a href={recycling}>recycling our packaging</a>.</p>
        </div>
    );
}
